import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import pricing from '../config/pricing.json';
import './Landing.css';

const APP_STORE = 'https://apps.apple.com/us/app/skillgate/id6755449463';
const CONTACT = 'skillgate.pro@gmail.com';

const Check = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
    <path d="M20 6 9 17l-5-5" />
  </svg>
);
const Arrow = () => (
  <svg className="btn-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);

// Tariffs (prices pulled from pricing.json so they stay in sync with backend)
const T = pricing.tariffs;
const TARIFFS = [
  { key: 'free', price: T.free.price, period: '',
    desc: '500 ₽ бонусом при регистрации. Попробуйте без оплаты.',
    feats: ['1 база вопросов', '1 тест-схема', 'Персональные приглашения', 'Полная аналитика результата'] },
  { key: 'hr', price: T.hr.price, period: '/мес', feat: true,
    desc: 'Групповое тестирование: одна ссылка на весь поток кандидатов.',
    feats: ['1 база, 1 тест-схема', '2 групповые ссылки', 'Массовое тестирование до 300 чел.', 'Автоматический отбор кандидатов'] },
  { key: 'standard', price: T.standard.price, period: '/мес',
    desc: 'Базовый тариф для регулярной оценки и аттестаций.',
    feats: ['1 база вопросов', '2 тест-схемы', 'Персональные приглашения', 'Детальная статистика'] },
  { key: 'unlimited', price: T.unlimited.price, period: '/мес',
    desc: 'Для команд и агентств с большим потоком тестирований.',
    feats: ['До 100 баз вопросов', 'До 1000 тест-схем', 'До 100 групповых ссылок', 'Приоритетная поддержка'] },
  { key: 'unlimited_plus', price: T.unlimited_plus.price, period: '/мес',
    desc: 'Unlimited + разработка базы на 300 вопросов под вашу вакансию.',
    feats: ['Всё из Unlimited', 'Разработка базы (300 вопросов)', 'Помощь в настройке', 'Персональный менеджер'] },
];

function Landing() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const root = document.querySelector('.sg');
    if (!root) return;

    const revealIO = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('in'); revealIO.unobserve(en.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -40px 0px' });
    root.querySelectorAll('.reveal').forEach((el, i) => {
      el.style.transitionDelay = (Math.min(i % 8, 8) * 0.06) + 's';
      revealIO.observe(el);
    });

    const animateCount = (el) => {
      const to = +el.dataset.to; const dur = 1400; const start = performance.now();
      const big = to >= 1000;
      const tick = (now) => {
        const p = Math.min((now - start) / dur, 1);
        const e = 1 - Math.pow(1 - p, 3);
        const v = Math.round(to * e);
        el.textContent = big ? v.toLocaleString('ru-RU') : v;
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    const countIO = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting && !en.target.dataset.done) {
          en.target.dataset.done = '1'; animateCount(en.target); countIO.unobserve(en.target);
        }
      });
    }, { threshold: 0.6 });
    root.querySelectorAll('.count').forEach((el) => countIO.observe(el));

    return () => { revealIO.disconnect(); countIO.disconnect(); };
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="sg">
      {/* NAV */}
      <header className="nav">
        <div className="container nav-inner">
          <Link className="brand" to="/"><img src="/project_logo.png" alt="Логотип SkillGate" />SkillGate</Link>
          <nav className="nav-menu">
            <a href="#features">Возможности</a>
            <a href="#how">Как работает</a>
            <a href="#banks">Базы вопросов</a>
            <a href="#security">Защита</a>
            <a href="#pricing">Тарифы</a>
          </nav>
          <div className="nav-cta">
            <Link to="/login" style={{ fontSize: '14.5px', fontWeight: 500, color: 'var(--ink-600)' }}>Войти</Link>
            <Link className="btn btn-primary btn-sm" to="/register">Регистрация</Link>
          </div>
          <button className="nav-burger" aria-label="Меню" onClick={() => setMenuOpen(!menuOpen)}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              {menuOpen ? <path d="M6 18 18 6M6 6l12 12" /> : <path d="M4 6h16M4 12h16M4 18h16" />}
            </svg>
          </button>
        </div>
        <div className={`nav-mobile ${menuOpen ? 'open' : ''}`}>
          <a href="#features" onClick={closeMenu}>Возможности</a>
          <a href="#how" onClick={closeMenu}>Как работает</a>
          <a href="#banks" onClick={closeMenu}>Базы вопросов</a>
          <a href="#audience" onClick={closeMenu}>Для кого</a>
          <a href="#security" onClick={closeMenu}>Защита от списывания</a>
          <a href="#pricing" onClick={closeMenu}>Тарифы</a>
          <Link to="/login" onClick={closeMenu}>Войти</Link>
          <Link className="btn btn-primary" to="/register" onClick={closeMenu} style={{ marginTop: 10 }}>Регистрация</Link>
        </div>
      </header>

      {/* HERO */}
      <section className="hero">
        <div className="hero-bg" />
        <div className="container">
          <div className="hero-inner">
            <span className="badge-pill reveal"><span className="dot" /> Платформа онлайн-тестирования <span className="tag">10 000+ тестов проведено</span></span>
            <h1 className="hero-title reveal">Тестирование знаний <span className="grad">без утечек и списывания</span></h1>
            <p className="hero-sub reveal">Каждый кандидат получает свой набор вопросов из вашей базы и проходит тест в приложении, где списать или передать ответы почти невозможно. <b style={{ color: 'var(--ink-800)', fontWeight: 600 }}>Не только IT</b>: бухгалтеры, юристы, продавцы, логисты, медперсонал. Возьмите готовую базу по специальности или соберите свою.</p>
            <div className="hero-actions reveal">
              <Link className="btn btn-primary" to="/register">Начать бесплатно <Arrow /></Link>
              <span className="bonus-chip">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 7v14" /></svg>
                500 ₽ бонусом при регистрации
              </span>
            </div>
            <p className="hero-note reveal">5 минут до первого теста · банковская карта не нужна</p>
          </div>

          {/* product mock */}
          <div className="hero-mock reveal">
            <div className="mock-bar">
              <span className="d" /><span className="d" /><span className="d" />
              <span className="mock-url">app.skillgate.pro/результаты/иван-петров</span>
            </div>
            <div className="mock-body">
              <div className="mock-card">
                <h4>Распределение по темам</h4>
                <div className="mock-bars">
                  {[['Python основы', 90], ['Базы данных / SQL', 75], ['Алгоритмы', 68], ['Сети и протоколы', 80]].map(([n, w]) => (
                    <div className="mb-row" key={n}>{n}<span style={{ float: 'right', fontWeight: 650 }}>{w}%</span><div className="mb-track"><div className="mb-fill" style={{ width: `${w}%` }} /></div></div>
                  ))}
                </div>
              </div>
              <div className="mock-card">
                <h4>Итоговый результат</h4>
                <div className="ring-row">
                  <div className="mini-ring"><span>82%</span></div>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 15 }}>Иван Петров</div>
                    <div style={{ fontSize: '12.5px', color: 'var(--ink-500)', marginTop: 3 }}>41 из 50 верных</div>
                    <div className="badge b-pass" style={{ marginTop: 10 }}><span className="bd" />Пройден</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* METRICS */}
      <section className="metrics">
        <div className="container">
          <div className="metrics-grid reveal">
            <div className="metric"><div className="num"><b><span className="count" data-to="10000">0</span>+</b></div><div className="lbl">проведено тестов</div></div>
            <div className="metric"><div className="num"><span className="count" data-to="100">0</span>%</div><div className="lbl">защита от утечек вопросов</div></div>
            <div className="metric"><div className="num"><span className="count" data-to="5">0</span> мин</div><div className="lbl">до первого теста</div></div>
            <div className="metric"><div className="num">∞</div><div className="lbl">для регулярного использования</div></div>
          </div>
        </div>
      </section>

      {/* USE CASES */}
      <section className="block" id="features" style={{ paddingTop: 30 }}>
        <div className="container">
          <div className="sec-head reveal">
            <span className="eyebrow">Сценарии применения</span>
            <h2 style={{ marginTop: 18 }}>Компании используют SkillGate для</h2>
          </div>
          <div className="usecases">
            {[
              { t: 'Найма сотрудников', d: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z' },
              { t: 'Внутренней аттестации', d: 'M9 11l3 3L22 4M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11' },
              { t: 'Проверки после обучения', d: 'M22 10v6M2 10l10-5 10 5-10 5z M6 12v5c0 1 2 3 6 3s6-2 6-3v-5' },
              { t: 'Аудита знаний', d: 'M11 17a6 6 0 1 0 0-12 6 6 0 0 0 0 12zM21 21l-5.2-5.2' },
            ].map((u) => (
              <div className="uc reveal" key={u.t}>
                <span className="ic"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d={u.d} /></svg></span>{u.t}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HOW IT WORKS: 4 steps */}
      <section className="block" id="how" style={{ paddingTop: 30 }}>
        <div className="container">
          <div className="sec-head reveal">
            <span className="eyebrow">Как это работает</span>
            <h2 style={{ marginTop: 18 }}>От регистрации до отчёта: 4 шага</h2>
            <p>Без методиста и долгой настройки. Первый скрининг можно запустить в день регистрации.</p>
          </div>
          <div className="steps">
            {[
              { n: 1, h: 'Зарегистрируйтесь', p: 'Создайте компанию за минуту. Сразу получите личный кабинет и 500 ₽ бонусом.' },
              { n: 2, h: 'Возьмите базу вопросов', p: 'Выберите готовую базу по специальности из каталога или соберите свою.', hi: 'Не сочиняете вопросы сами' },
              { n: 3, h: 'Отправьте ссылку', p: 'Кандидат проходит тест в мобильном приложении под защитой от списывания.' },
              { n: 4, h: 'Получите отчёт', p: 'Балл, разбивка по темам и флаги списывания. Сразу понятно, звать на интервью или нет.' },
            ].map((s) => (
              <div className="step reveal" key={s.n}>
                <div className="snum">{s.n}</div>
                <h3>{s.h}</h3>
                <p>{s.p}</p>
                {s.hi && <span className="shi">{s.hi}</span>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SPECIALTY BANKS */}
      <section className="block" id="banks" style={{ paddingTop: 20 }}>
        <div className="container">
          <div className="sec-head reveal">
            <span className="eyebrow">Готовые базы вопросов</span>
            <h2 style={{ marginTop: 18 }}>Каталог готовых баз по специальностям</h2>
            <p>Не только IT. Возьмите проверенную базу под нужную профессию и запускайте скрининг сразу: вопросы уже составлены.</p>
          </div>
          <div className="spec-grid">
            {[
              { i: '🧮', t: 'Бухгалтер', c: 'Учёт, ПБУ, НК РФ' },
              { i: '💼', t: 'Менеджер по продажам', c: 'Воронка, работа с возражениями' },
              { i: '⚖️', t: 'Юрист', c: 'Договоры, ГК РФ, претензии' },
              { i: '🚚', t: 'Логист / ВЭД', c: 'Инкотермс, ТН ВЭД, поставки' },
              { i: '🛡️', t: 'Кадровик / охрана труда', c: 'КДП, ТК РФ, инструктажи' },
              { i: '🩺', t: 'Медперсонал', c: 'Регистратура, протоколы' },
              { i: '💻', t: 'IT-специалист', c: 'Языки, БД, сети' },
              { i: '📈', t: 'Маркетолог', c: 'Каналы, аналитика, метрики' },
            ].map((s) => (
              <div className="spec reveal" key={s.t}>
                <span className="si">{s.i}</span>
                <div><div className="st">{s.t}</div><div className="sc">{s.c}</div></div>
              </div>
            ))}
          </div>
          <p style={{ textAlign: 'center', color: 'var(--ink-400)', fontSize: '13.5px', marginTop: 24 }}>
            Каталог пополняется. Нет нужной специальности? Соберите свою базу за минуты.
          </p>
        </div>
      </section>

      {/* AUDIENCE */}
      <section className="block" id="audience" style={{ paddingTop: 30 }}>
        <div className="container">
          <div className="sec-head reveal">
            <span className="eyebrow">Для кого</span>
            <h2 style={{ marginTop: 18 }}>Свой режим под каждую задачу</h2>
            <p>HR, корпоративное обучение и аттестации работают на одной платформе с разными инструментами.</p>
          </div>
          <div className="aud-grid">
            {[
              { ic: 'a1', icon: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z', h: 'Для HR-специалистов', role: 'Подбор и скрининг', li: ['Отдельный режим HR-поиска', 'Групповые ссылки: тест сразу 100 кандидатам', 'Автоматический отбор', 'Подробная статистика по каждому'] },
              { ic: 'a2', icon: 'M22 10v6M2 10l10-5 10 5-10 5z M6 12v5c0 1 2 3 6 3s6-2 6-3v-5', h: 'Для корпоративного обучения', role: 'L&D и тренинги', li: ['Групповые тесты после каждого модуля', 'Детальная статистика по вопросам', 'Сравнение результатов групп', 'Экспорт данных для анализа'] },
              { ic: 'a3', icon: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z M9 12l2 2 4-4', h: 'Для аттестаций', role: 'Независимая оценка', li: ['Независимая платформа', '100% защита от утечек', 'Настройка за 5 минут', 'Регулярные аттестации'] },
            ].map((c) => (
              <div className="aud-card reveal" key={c.h}>
                <div className={`aud-ic ${c.ic}`}><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d={c.icon} /></svg></div>
                <h3>{c.h}</h3>
                <div className="role">{c.role}</div>
                <ul>{c.li.map((x) => <li key={x}><Check />{x}</li>)}</ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECURITY / MOBILE APP */}
      <section className="block" id="security" style={{ paddingTop: 20 }}>
        <div className="container">
          <div className="anti">
            <div className="reveal">
              <span className="eyebrow">Защита от списывания</span>
              <h2 style={{ fontFamily: 'var(--display)', fontSize: 'clamp(28px,3.4vw,40px)', letterSpacing: '-0.03em', margin: '18px 0 12px', lineHeight: 1.1 }}>
                Кандидат проходит тест в&nbsp;приложении SkillGate
              </h2>
              <p style={{ color: 'var(--ink-600)', fontSize: '16.5px', maxWidth: 520 }}>
                Вы отправляете ссылку-приглашение, а кандидат проходит тест в нашем приложении, в защищённой среде, где списать или передать ответы почти невозможно. Если кто-то попытается схитрить, вы увидите это в отчёте по кандидату.
              </p>
              <div className="anti-feats">
                {[
                  { icon: 'M5 11h14v10H5zM8 11V8a4 4 0 0 1 8 0v3', h: 'Защищённая среда', p: 'Тест проходит в приложении, а не в браузере. Окружение спроектировано так, чтобы обойти его не получилось.' },
                  { icon: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z M9 12l2 2 4-4', h: 'Антисписывание, которое работает', p: 'Платформа сама отслеживает честность прохождения. Результат вы видите в отчёте по кандидату, а решение остаётся за вами.' },
                  { icon: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z', h: 'Уникальный тест каждому', p: 'Для каждого собирается своя выборка вопросов из вашей базы. Одинаковых тестов не бывает.' },
                ].map((f) => (
                  <div className="anti-feat" key={f.h}>
                    <span className="afi"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d={f.icon} /></svg></span>
                    <div><h4>{f.h}</h4><p>{f.p}</p></div>
                  </div>
                ))}
              </div>
              <a className="store-btn" href={APP_STORE} target="_blank" rel="noopener noreferrer">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M16.5 3c.1 1-.3 2-1 2.7-.7.8-1.8 1.4-2.8 1.3-.1-1 .4-2 1-2.7C14.5 3.6 15.6 3 16.5 3zM19 17c-.5 1.2-.8 1.7-1.5 2.7-1 1.4-2.3 3.1-4 3.1-1.4 0-1.8-.9-3.7-.9s-2.4.9-3.7.9c-1.7 0-3-1.6-4-3C-.7 16.5-.9 11 1.6 8.2c1-1.3 2.6-2.1 4-2.1 1.5 0 2.5 1 3.7 1 1.2 0 1.9-1 3.7-1 1.2 0 2.5.7 3.4 1.8-3 1.7-2.5 6 .6 7.1z" /></svg>
                Скачать в App Store
              </a>
            </div>

            <div className="anti-visual reveal">
              <div className="phone">
                <div className="phone-screen">
                  <div className="pq">Вопрос 7 из 25 · Backend (Python)</div>
                  <div className="pt">Что выведет {'print(type([]))'}?</div>
                  <div className="phone-opt">{"<class 'dict'>"}</div>
                  <div className="phone-opt sel">{"<class 'list'>"}</div>
                  <div className="phone-opt">{"<class 'tuple'>"}</div>
                  <div className="phone-guard">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2 4 5v6c0 5 3.5 8.5 8 10 4.5-1.5 8-5 8-10V5z" /></svg>
                    Защищённый режим прохождения
                  </div>
                </div>
              </div>
              <div className="anti-badge">
                <span className="ab-ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z M9 12l2 2 4-4" /></svg></span>
                Защита от списывания
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* RESULTS */}
      <section className="block" style={{ paddingTop: 10 }}>
        <div className="container">
          <div className="results-wrap reveal">
            <span className="eyebrow">Результаты</span>
            <h2>Скрининг при найме, который окупается</h2>
            <p className="rsub">Объективные данные вместо интуиции. Команды нанимают быстрее.</p>
            <div className="res-grid">
              <div className="res-item"><div className="rn">×<span className="count" data-to="3">0</span></div><div className="rl">больше кандидатов обрабатывается за то же время</div></div>
              <div className="res-item"><div className="rn"><span className="count" data-to="15">0</span>+ ч</div><div className="rl">экономия времени рекрутера в неделю</div></div>
              <div className="res-item"><div className="rn">−<span className="count" data-to="50">0</span>%</div><div className="rl">снижение времени найма</div></div>
            </div>
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section className="block" id="pricing" style={{ paddingTop: 30 }}>
        <div className="container">
          <div className="sec-head reveal">
            <span className="eyebrow">Тарифы</span>
            <h2 style={{ marginTop: 18 }}>Прозрачные цены без скрытых платежей</h2>
            <p>Начните бесплатно с 500 ₽ бонусом. Тариф можно сменить в любой момент.</p>
          </div>
          <div className="price-grid">
            {TARIFFS.map((t) => (
              <div className={`price-card reveal ${t.feat ? 'feat' : ''}`} key={t.key}>
                <div className="price-name">{T[t.key].name}</div>
                <div className="price-val">
                  {t.price === 0 ? 'Бесплатно' : <>{t.price.toLocaleString('ru-RU')} ₽<small>{t.period}</small></>}
                </div>
                <div className="price-desc">{t.desc}</div>
                <ul>{t.feats.map((f) => <li key={f}><Check />{f}</li>)}</ul>
                <Link className={`btn ${t.feat ? 'btn-primary' : 'btn-ghost'}`} to="/register">
                  {t.price === 0 ? 'Начать бесплатно' : 'Выбрать тариф'}
                </Link>
              </div>
            ))}
          </div>
          <div className="price-note">
            <div className="pn-item">Проверка кандидата: <b>{pricing.candidate_test.price} ₽</b> за результат</div>
            <div className="pn-item">База вопросов под ключ: от <b>{pricing.question_bank.price_per_300_questions.toLocaleString('ru-RU')} ₽</b> за 300 вопросов</div>
            <div className="pn-item">Нужен пакет под объём? <a href={`mailto:${CONTACT}`} style={{ color: 'var(--blue-600)', fontWeight: 600 }}>Напишите нам</a></div>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="block" style={{ paddingTop: 10 }}>
        <div className="container">
          <div className="final-cta reveal">
            <h2>Попробуйте бесплатно</h2>
            <p>Зарегистрируйтесь сегодня и получите 500 ₽ бонусом на первые тесты.</p>
            <div className="row">
              <Link className="btn btn-primary" to="/register">Начать бесплатно <Arrow /></Link>
              <Link className="btn btn-ghost" to="/login">Войти в кабинет</Link>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="lf">
        <div className="container">
          <div className="lf-top">
            <Link className="brand" to="/"><img src="/project_logo.png" alt="Логотип SkillGate" />SkillGate</Link>
            <div className="lf-links">
              <a href="#features">Возможности</a>
              <a href="#pricing">Тарифы</a>
              <a href={APP_STORE} target="_blank" rel="noopener noreferrer">Приложение iOS</a>
              <a href={`mailto:${CONTACT}`}>Связаться</a>
              <Link to="/privacy-policy">Политика обработки данных</Link>
              <Link to="/terms-of-service">Пользовательское соглашение</Link>
              <Link to="/public-offer">Публичная оферта</Link>
            </div>
          </div>
          <div className="lf-legal">
            ИП Вихляев Сергей Николаевич · ИНН 682004283576<br />
            © 2026 SkillGate. Платформа онлайн-тестирования знаний и навыков.
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Landing;
